import axios from 'apis';
import { sessionService } from 'redux-react-session';
import { getThunkActionCreator } from 'redux-thunk-routine';
import {
  getPublicTruckInspectionRoutine,
  submitPublicTruckInspectionRoutine,
  createTruckInspectionReportRoutine,
} from 'actions';
import {
  TRUCK_INSPECTION_EQUIPMENT_FIELDS,
  equipmentRepairDateKey,
  equipmentStatusKey,
} from 'helpers/truckInspectionEquipmentFields';

const reportSummaryAttributes = [
  'id',
  'status',
  'inspected_by',
  'inspected_on',
  'expires_on',
  'public_url',
  'created_at',
];

const reportDetailAttributes = [
  'id',
  'status',
  'tow_company_name',
  'street_address',
  'city',
  'state',
  'zip',
  'vehicle_year',
  'vehicle_make',
  'vehicle_model',
  'vin',
  'vehicle_license_plate_number',
  'gvwr_class',
  'vehicle_type_pdf',
  'vehicle_type_other',
  'inspected_by',
  'inspected_on',
  'expires_on',
  'public_url',
  ...TRUCK_INSPECTION_EQUIPMENT_FIELDS.flatMap((field) => [
    equipmentStatusKey(field),
    equipmentRepairDateKey(field),
  ]),
];

export const getPublicTruckInspection = getThunkActionCreator(
  getPublicTruckInspectionRoutine,
  async (id) => axios.get(`/public/truck_inspection_reports/${id}`)
);

export const submitPublicTruckInspection = getThunkActionCreator(
  submitPublicTruckInspectionRoutine,
  async ({ id, annual_truck_inspection_report }) =>
    axios.patch(`/public/truck_inspection_reports/${id}`, { annual_truck_inspection_report })
);

export const createTruckInspectionReport = getThunkActionCreator(
  createTruckInspectionReportRoutine,
  async (truckId) => {
    const { token: access_token } = await sessionService.loadSession();

    return axios.post(`/user/trucks/${truckId}/inspection_reports`, {
      access_token,
      attributes: reportDetailAttributes,
    });
  }
);

export { reportSummaryAttributes, reportDetailAttributes };
